var path = 'app/scripts/modules/core/src/task/modal/reason.directive.html';
var html = "<div class=\"row\" style=\"margin-top:10px; margin-bottom:10px\">\n  <div class=\"col-md-3 sm-label-right\">Reason</div>\n  <div class=\"col-md-7\">\n    <textarea class=\"form-control\" ng-model=\"vm.command.reason\" rows=\"3\"\n              placeholder=\"(Optional) anything that might be helpful to explain the reason for this change; HTML is okay\"></textarea>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/task/modal/reason.directive.html
// module id = 1127
// module chunks = 0